import React from 'react';
import PropTypes from 'prop-types';

import Table from 'common/Table';
import BaseComponent from 'common/BaseComponent';
import {getMessage as msg} from 'MessageBundle';
import readIcon from './read.png';
import duplicateIcon from './duplicate.png';
import theme from './../InvoiceTab.scss';
import {floatToString} from 'utils/Number'

export default class DuplicateTable extends BaseComponent {

    constructor(props) {
        super(props);
        this.tableStructure = [
            {
                label: msg('invoiceTab.duplicateTable.detailsHeader'), sortable: false,
                width: '63px', headStyle: theme.columnDetails, bodyStyle: theme.txtCenter,
                render: (row) => {
                    return (
                        <a href="javascript:void(0)" onClick={this.openComplaint(row, ['readonly'])} title={msg('invoiceTab.duplicateTable.detailsTitle')}>
                            <img src={readIcon} alt=""/>
                        </a>
                    );
                }
            },
            {
                attribute: "hvo", label: msg('invoiceTab.duplicateTable.hvoHeader'),
                width: '75px', headStyle: theme.columnDuplicateHvo, bodyStyle: theme.txtRight,
                render: (row) => {
                    return row.hvo;
                }
            },
            {
                attribute: "uvo", label: msg('invoiceTab.duplicateTable.uvoHeader'),
                width: '75px', headStyle: theme.columnDuplicateUvo, bodyStyle: theme.txtRight,
                render: (row) => {
                    return row.uvo;
                }
            },
            {
                attribute: "invoiceNumber", label: msg('invoiceTab.duplicateTable.invoiceNumberHeader'),
                width: '120px', headStyle: theme.columnDuplicateInvoiceNumber,
                bodyStyle: (row) => row.invoiceNumberDuplicate ? theme.columnDisable + ' ' + theme.txtRight : theme.txtRight,
                render: (row) => {
                    return row.invoiceNumber;
                }
            },
            {
                attribute: "invoiceNumberNew", label: msg('invoiceTab.duplicateTable.invoiceNumberNewHeader'),
                fullLabel: msg("invoiceTab.duplicateTable.invoiceNumberNewHeader.full"),
                width: '120px',
                bodyStyle: (row) => row.invoiceNumberNewDuplicate ? theme.columnDisable + ' ' + theme.txtRight : theme.txtRight,
                render: (row) => {
                    return <div title={msg('invoiceTab.duplicateTable.invoiceNumberNewTitle')}>{row.invoiceNumberNew}</div>
                }
            },
            {
                attribute: "deliveryNoteNumber", label: msg('invoiceTab.duplicateTable.deliveryNoteNumberHeader'),
                fullLabel: msg("invoiceTab.duplicateTable.deliveryNoteNumberHeader.full"),
                width: '100px', headStyle: theme.columnDuplicateDeliveryNoteNumber,
                bodyStyle: (row) => row.deliveryNoteNumberDuplicate ? theme.columnDisable + ' ' + theme.txtRight : theme.txtRight,
                render: (row) => {
                    return row.deliveryNoteNumber;
                }
            },
            {
                attribute: "complaintNumber", label: msg('invoiceTab.duplicateTable.complaintNumberHeader'),
                fullLabel: msg("invoiceTab.duplicateTable.complaintNumberHeader.full"),
                width: '100px', headStyle: theme.columnDuplicateComplaintNumber,
                render: (row) => {
                    return row.complaintNumber;
                }
            },
            {
                attribute: "reason", label: msg('invoiceTab.duplicateTable.reasonHeader'),
                width: '150px', headStyle: theme.columnDuplicateReason,
                render: (row) => {
                    return <div className={theme.txtOverflow} title={row.reason}>{row.reason}</div>;
                }
            },
            {
                attribute: "approvedAmountNet", label: msg('invoiceTab.duplicateTable.approvedAmountNetHeader'),
                fullLabel: msg("invoiceTab.duplicateTable.approvedAmountNetHeader.full"),
                width: '180px', headStyle: theme.columnDuplicateApprovedAmountNet,
                render: (row) => {
                    return <div title={msg('invoiceTab.duplicateTable.approvedAmountNetTitle')}>{row.approvedAmountNet?floatToString(row.approvedAmountNet):""}</div>
                }
            },
            {
                attribute: "basket", label: msg('invoiceTab.duplicateTable.basketHeader'),
                width: '100px', headStyle: theme.columnDuplicateBasket,
                render: (row) => {
                    return <div className={theme.txtOverflow} title={row.basket}>{row.basket}</div>;
                }
            },
            {
                label: msg('invoiceTab.duplicateTable.actionHeader'), sortable: false,
                width: '64px', bodyStyle: theme.txtCenter,
                render: (row) => {
                    return (
                        <a href="javascript:void(0)" onClick={this.props.onChoose(row.complaintNumber)} title={msg('invoiceTab.duplicateTable.duplicateActionTitle')}>
                            <img src={duplicateIcon} alt=""/>
                        </a>
                    );
                }
            }
        ];
    }

    render() {
        return (
            <div>
                <h3>{msg('invoiceTab.duplicateTable.header')}</h3>
                <span>{msg('invoiceTab.duplicateTable.counter')} {this.props.value.length}</span>

                <div className={theme.tblWrap}>
                    <div className={theme.tblWrapInner}>
                        <Table structure={this.tableStructure} value={this.props.value} sortable  className={theme.invoiceTabTbl + ' ' + theme.duplicateTbl}/>
                    </div>
                </div>
            </div>
        );
    }
}

DuplicateTable.PropTypes = {
    /**
     * Array of the duplicates to be shown in the table.
     */
    value: PropTypes.array.required,

    /**
     * JavaScript function that has to be invoked on duplicate choose.
     */
    onChoose: PropTypes.func.required
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/InvoiceTab/DuplicateTable/index.js